var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.196,
    height: 27.561,
    viewBox: "0 0 20.196 27.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87680",
    "data-name": "Path 87680",
    d: "M31.93,21.959,15.662,10.133a1.962,1.962,0,0,0-3.115,1.582V35.358a1.955,1.955,0,0,0,1.071,1.749,1.976,1.976,0,0,0,.892.211,1.95,1.95,0,0,0,1.152-.381L31.93,25.124a1.946,1.946,0,0,0,0-3.165Z",
    transform: "translate(-12.547 -9.758)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b59442a4505b0470939085bb286fca11.svg";
export { ForwardRef as ReactComponent };